import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import get from 'lodash/get';

import { Niche } from 'rebook/apps/catalog/models';
import numberWithSpace from 'rebook/apps/utils/text/numberWithSpace';
import CatalogItemImage from 'rebook/apps/catalog/components/CatalogItemImage';

import styles from './style.scss';


const CatalogNicheItem = ({ niche, booksNiche }) => {
  const nicheItem = niche || booksNiche;
  let NicheModel;

  if (niche) {
    NicheModel = new Niche(niche);
  }

  return (
    <Link to={NicheModel ? NicheModel.getLink() : nicheItem.url}>
      <div className={classNames('billetContainer', styles.nicheItem)}>
        <div>
          <big><b>{nicheItem.name}</b></big>
          <div className={styles.nicheBookCount}>
            <span>
              {numberWithSpace(get(nicheItem, 'counters.text', 0))}&nbsp;
              <i className={styles.bookCountIcon} />
            </span>
            <span className={styles.audioCount}>
              {numberWithSpace(get(nicheItem, 'counters.audio', 0))}&nbsp;
              <i className={styles.audioCountIcon} />
            </span>
          </div>
        </div>
        <div className={styles.nicheImage}>
          <CatalogItemImage imageSrc={nicheItem.image} src={nicheItem.name} width="64" height="64" />
        </div>
      </div>
    </Link>
  );
};

export default CatalogNicheItem;
